const config = {
  apiUrl: 'https://deg8gsutn3.execute-api.us-east-2.amazonaws.com', // Update this URL as needed
};

export default config;
